import { __decorate as t, __classPrivateFieldGet as e, __classPrivateFieldSet as s } from "tslib";
import { css as i, LitElement as r, html as o } from "lit";
import { property as l } from "lit/decorators.js";
import { generateId as n } from "../../utilities/utils.js";
import a from "@inera/ids-design/components/alert/alert-lit.js";
var c, d, h, p, u, _, b, C, O, f, v, g;
class y extends r {
  constructor() {
    super(...arguments), c.set(this, !1), d.set(this, !1), h.set(this, !1), p.set(this, !1), u.set(this, ""), _.set(this, !1), b.set(this, "info"), C.set(this, "Stäng alert"), O.set(this, "Minimera alertmeddelande"), f.set(this, "Expandera alertmeddelande"), v.set(this, ""), g.set(this, !1);
  }
  get collapsable() {
    return e(this, c, "f");
  }
  set collapsable(t) {
    s(this, c, t, "f");
  }
  get ribbon() {
    return e(this, d, "f");
  }
  set ribbon(t) {
    s(this, d, t, "f");
  }
  get collapsed() {
    return e(this, h, "f");
  }
  set collapsed(t) {
    s(this, h, t, "f");
  }
  get dismissible() {
    return e(this, p, "f");
  }
  set dismissible(t) {
    s(this, p, t, "f");
  }
  get headline() {
    return e(this, u, "f");
  }
  set headline(t) {
    s(this, u, t, "f");
  }
  get compact() {
    return e(this, _, "f");
  }
  set compact(t) {
    s(this, _, t, "f");
  }
  get type() {
    return e(this, b, "f");
  }
  set type(t) {
    s(this, b, t, "f");
  }
  get srclosetext() {
    return e(this, C, "f");
  }
  set srclosetext(t) {
    s(this, C, t, "f");
  }
  get srcollapsetext() {
    return e(this, O, "f");
  }
  set srcollapsetext(t) {
    s(this, O, t, "f");
  }
  get srexpandtext() {
    return e(this, f, "f");
  }
  set srexpandtext(t) {
    s(this, f, t, "f");
  }
  get sricontitle() {
    return e(this, v, "f");
  }
  set sricontitle(t) {
    s(this, v, t, "f");
  }
  get norole() {
    return e(this, g, "f");
  }
  set norole(t) {
    s(this, g, t, "f");
  }
  firstUpdated(t) {
    super.firstUpdated(t), this.setupScreenreader(), this.updateCompact();
  }
  updated(t) {
    super.updated(t), this.updateCompact();
  }
  setupScreenreader() {
    if (!this.getAttribute("role") && !this.norole) {
      this.setAttribute("role", "alert");
      const t = this.querySelector("[slot=headline]");
      if (t) switch (t.tagName) {
        case "H1":
        case "H2":
        case "H3":
        case "H4":
        case "H5":
        case "H6":
          if (t.id) this.setAttribute("aria-labelledby", t.id);else {
            const e = n();
            t.setAttribute("id", e), this.setAttribute("aria-labelledby", e);
          }
          return;
      }
    }
  }
  updateCompact() {
    this.compact = !Boolean(this.headline) && !this.querySelector("[slot=headline]") && !this.ribbon;
  }
  close() {
    let t = new CustomEvent("closed");
    this.dispatchEvent(t);
  }
  toggleCollapse() {
    this.collapsed = !this.collapsed;
    let t = new CustomEvent("collapsed", {
      detail: {
        isCollapsed: this.collapsed
      }
    });
    this.dispatchEvent(t);
  }
  getIconColor() {
    switch (this.type) {
      case "attention":
        return {
          color: "var(--IDS-ALERT--ATTENTION__ICON-COLOR-1)",
          color2: "var(--IDS-ALERT--ATTENTION__ICON-COLOR-2)"
        };
      case "success":
        return {
          color: "var(--IDS-ALERT--SUCCESS__ICON-COLOR-1)",
          color2: "var(--IDS-ALERT--SUCCESS__ICON-COLOR-2)"
        };
      case "error":
        return {
          color: "var(--IDS-ALERT--ERROR__ICON-COLOR-1)",
          color2: "var(--IDS-ALERT--ERROR__ICON-COLOR-2)"
        };
      default:
        return {
          color: "var(--IDS-ALERT--INFO__ICON-COLOR-1)",
          color2: "var(--IDS-ALERT--INFO__ICON-COLOR-2)"
        };
    }
  }
  renderButton() {
    return this.dismissible ? o`<div class="ids-alert__button"><button class="ids-alert__close" @click="${this.close}" aria-label="${this.srclosetext}"><ids-icon-close-bold color="var(--IDS-ALERT__ICON-COLOR)" width="100%" height="${this.ribbon ? "1rem" : "1.5rem"}"></ids-icon-close-bold></button></div>` : this.collapsable ? o`<div class="ids-alert__button"><button class="ids-alert__expand" @click="${this.toggleCollapse}" aria-expanded="${!this.collapsed}" aria-controls="alert-content" aria-label="${this.collapsed ? this.srexpandtext : this.srcollapsetext}"><ids-icon-chevron color="var(--IDS-ALERT__ICON-COLOR)" width="100%" height="1.5rem" rotate="${this.collapsed ? "90" : "-90"}"></ids-icon-chevron></button></div>` : o``;
  }
  renderIcon() {
    const t = this.ribbon ? "" : "ids-alert__state-icon",
      {
        color: e,
        color2: s
      } = this.getIconColor();
    return "attention" === this.type ? o`<ids-icon-attention title="${this.sricontitle}" color="${e}" color2="${s}" width="100%" height="100%" class="${t}"></ids-icon-attention>` : "success" === this.type ? o`<ids-icon-success title="${this.sricontitle}" color="${e}" color2="${s}" width="100%" height="100%" class="${t}"></ids-icon-success>` : "error" === this.type ? o`<ids-icon-warning title="${this.sricontitle}" color="${e}" color2="${s}" width="100%" height="100%" class="${t}"></ids-icon-warning>` : o`<ids-icon-information title="${this.sricontitle}" color="var(--IDS-ALERT--INFO__ICON-COLOR-1)" color2="var(--IDS-ALERT--INFO__ICON-COLOR-2)" width="100%" height="100%" class="${t}"></ids-icon-information>`;
  }
  renderWithHeadline() {
    return o`<div class="ids-alert__header"><div class="ids-alert__icon_and_text">${this.renderIcon()}<div class="ids-alert__headline">${this.headline.length > 0 ? o`<h2>${this.headline}</h2>` : o`<slot name="headline"></slot>`}</div></div>${this.renderButton()}</div><div class="ids-alert__content">${this.renderContent()}</div>`;
  }
  renderContent() {
    return this.collapsed ? o`` : o`<slot></slot>`;
  }
  renderWithoutHeadline() {
    return o`<div class="ids-alert__content"><div class="ids-alert__icon_and_text"><div class="ids-alert__content__icon">${this.renderIcon()}</div><div class="ids-alert__content__text">${this.renderContent()}</div></div>${this.renderButton()}</div>`;
  }
  renderAlert() {
    return this.compact || this.ribbon ? this.renderWithoutHeadline() : this.renderWithHeadline();
  }
  getAlertStateClasses() {
    return `ids-alert--${this.type.toLowerCase()} \n    ${this.collapsed ? " ids-alert--collapsed" : ""}\n    ${this.ribbon ? " ids-alert--ribbon" : ""}\n    ${this.compact ? " ids-alert--compact" : ""}`;
  }
  render() {
    return o`<div class="ids-alert ${this.getAlertStateClasses()}">${this.renderAlert()}</div>`;
  }
}
c = new WeakMap(), d = new WeakMap(), h = new WeakMap(), p = new WeakMap(), u = new WeakMap(), _ = new WeakMap(), b = new WeakMap(), C = new WeakMap(), O = new WeakMap(), f = new WeakMap(), v = new WeakMap(), g = new WeakMap(), y.styles = [i`:host{display:block}`, a], t([l({
  type: Boolean
})], y.prototype, "collapsable", null), t([l({
  type: Boolean,
  reflect: !0
})], y.prototype, "ribbon", null), t([l({
  type: Boolean,
  reflect: !0
})], y.prototype, "collapsed", null), t([l({
  type: Boolean
})], y.prototype, "dismissible", null), t([l({
  type: String
})], y.prototype, "headline", null), t([l({
  type: Boolean,
  reflect: !0
})], y.prototype, "compact", null), t([l({
  type: String
})], y.prototype, "type", null), t([l({
  type: String
})], y.prototype, "srclosetext", null), t([l({
  type: String
})], y.prototype, "srcollapsetext", null), t([l({
  type: String
})], y.prototype, "srexpandtext", null), t([l({
  type: String
})], y.prototype, "sricontitle", null), t([l({
  type: Boolean
})], y.prototype, "norole", null);
export { y as IDSAlert };